
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aplikacje-flutter-android-ios",
      function () {
        return require("private-next-pages/aplikacje-flutter-android-ios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aplikacje-flutter-android-ios"])
      });
    }
  